import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

export const ChristmasWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  height: 80px;
`;

export const ScaledContent = styled.div`
  position: relative;
  transform-origin: top left;
  display: flex;

  @media (max-width: ${breakpoints.l}) {
    transform: scale(0.8);
  }
`;

export const DesktopWrapper = styled.div`
  position: relative;
  display: flex;
  left: -50px;
  top: -10px;
  transition: left 0.3s ease-in-out;

  @media (max-width: ${breakpoints.l}) {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: none;

  @media (max-width: ${breakpoints.l}) {
    position: relative;
    display: flex;
    left: -35px;
    top: -7px;
  }
`;

export const LightsWrapper = styled.div`
  position: relative;
`;

export const SnowContainer = styled.div`
  display: flex;
`;

export const SmallSnowWrapper = styled.div`
  position: relative;
  left: -20px;

  @media (max-width: ${breakpoints.l}) {
    left: -35px;
    height: 50px;
  }
`;

export const LargeSnowWrapper = styled.div`
  position: relative;

  @media (max-width: ${breakpoints.l}) {
    display: none;
  }
`;
